import type { CaixaTransactionRow } from "@/features/caixas/types";

export function displayCaixaObservation(
  row: Pick<
    CaixaTransactionRow,
    "kind" | "observation" | "undo_of_transaction_id"
  >,
): string {
  if (
    row.kind === "undo" &&
    row.undo_of_transaction_id &&
    row.observation?.trim() ===
      `Desfazimento da movimentação ${row.undo_of_transaction_id}`
  ) {
    return "Desfazimento de movimentação";
  }
  return row.observation || "Sem observação.";
}

export function shortCaixaReference(id: string): string {
  return `#${id.slice(0, 8)}`;
}
